export const TOKEN_KEY = process.env.REACT_APP_USER_KEY;

export function getDadosLocalStorage() {
  let localStorageDados = localStorage.getItem(TOKEN_KEY)

  if (localStorageDados) {
    return atob(localStorageDados)
  }

  return null
}

export function setLocalStorage(value) {
  localStorage.setItem(TOKEN_KEY, btoa(JSON.stringify(value)))
}


/*
  config:{
    filterObrigacao:...,
    filterConsultaCertidaoAtiva:...
  }

*/

export function getStateLocalStorage(filterParm) {

  let dadoLocalStorage = getDadosLocalStorage();
  if (dadoLocalStorage) {
    let json = JSON.parse(dadoLocalStorage)
    let { config } = json

    if (config) {
      let filter = config[filterParm]

      if (filter) return filter;
    }
  }

  return null
}

export function setStateLocalStorage(value, filterParm) {

  let dadoLocalStorage = getDadosLocalStorage();

  if (dadoLocalStorage) {
    let json = JSON.parse(dadoLocalStorage)
    json.config[filterParm] = { ...value }
    setLocalStorage(json)
  }
}